import React from "react";
import ReportPopupLink from "./ReportPopupLink";

const ReportHome = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column", marginTop: "20px", marginLeft: "40px", gap: "10px" }}>
      <ReportPopupLink
        to="/reports/report1"
        style={{ color: "#810055", fontSize: "13px", textDecoration: "none", fontFamily: "GEG-Body" }}
      >
        1. Training Need Identification along with Status 
      </ReportPopupLink>
      <ReportPopupLink
        to="/reports/batch_details"
        style={{ color: "#810055", fontSize: "13px", textDecoration: "none", fontFamily: "GEG-Body" }}
      >
        2. Batch Details
      </ReportPopupLink>
      <ReportPopupLink
        to="/reports/emp_trng_completion"
        style={{ color: "#810055", fontSize: "13px", textDecoration: "none", fontFamily: "GEG-Body" }}
      >
        3. Employee wise Training Completion Details
      </ReportPopupLink>
      <ReportPopupLink
        to="/reports/emp_trng_ident"
        style={{ color: "#810055", fontSize: "13px", textDecoration: "none", fontFamily: "GEG-Body" }}
      >
        4. Employee wise Training Identified
      </ReportPopupLink>
      <ReportPopupLink
        to="/reports/trng_man_hrs"
        style={{ color: "#810055", fontSize: "13px", textDecoration: "none", fontFamily: "GEG-Body" }}
      >
        5. Training wise Manhour Calculations
      </ReportPopupLink>
      <ReportPopupLink
        to="/reports/trng_batch_status"
        style={{ color: "#810055", fontSize: "13px", textDecoration: "none", fontFamily: "GEG-Body" }}
      >
        6. Training Batch Status
      </ReportPopupLink>
      <ReportPopupLink
        to="/reports/trng_matrix"
        style={{ color: "#810055", fontSize: "13px", textDecoration: "none", fontFamily: "GEG-Body" }}
      >
        7. Training Matrix Report
      </ReportPopupLink>
    </div>
  );
};

export default ReportHome;
